import angular from 'angular'
import jQuery from 'jquery'

import './polyfill.js'
import './main.js'

import { deskfyConfig } from './deskfy.config.js'
import { deskfyRoutes } from './deskfy.routes.js'
import { analyticsRoutes } from './analytics/analytics.routes'
import { onboardingRoutes } from './onboarding/onboarding.routes'
import { damRoutes } from './dam/dam.routes'
import { repositoryRoutes } from './repository/repository.module.routes'
import { campaignsRoutes } from './campaigns/campaigns.module.routes.js'
import { documentsRoutes } from './documents/documents.routes'
import { editorRoutes } from './editor/editor.routes'
import { deskfyRun } from './deskfy.run.js'
import { coreModule } from './core/core.module'
import { artModule } from './arts/arts.module.js'
import { adminModule } from './admin/admin.module'
import { auditModule } from './audit/audit.module'
import { authModule } from './auth/auth.module'
import { brandModule } from './brand/brand.module'
import { guestModule } from './guest/guest.module'
import { homeModule } from './home/home.module'
import { iaModule } from './ia/ia.module'
import { postsModule } from './posts/posts.module'
import { profileModule } from './profile/profile.module'
import { workflowModule } from './workflow/workflow.module'
import { repositoryModule } from './repository/repository.module'
import { campaignsModule } from './campaigns/campaigns.module'
import { documentsModule } from './documents/documents.module'

import { defineCustomElements } from '@deskfy/unify-design-system/loader'

import './core/directives/deskfy-loader/deskfy-loader.controller'
import './core/directives/deskfy-loader/deskfy-loader.directive'
import './core/directives/avatar/avatar.directive'
import './core/directives/activity-item/activity-item.controller'
import './core/directives/activity-item/activity-item.directive'
import './core/directives/input-emoji/input-emoji.controller'
import './core/directives/input-emoji/input-emoji.directive'
import './core/directives/attachment-list-item/attachment-list-item.controller'
import './core/directives/attachment-list-item/attachment-list-item.directive'
import './core/directives/comment-item/comment-item.controller'
import './core/directives/comment-item/comment-item.directive'
import './core/directives/deskfy-header/deskfy-header.controller'
import './core/directives/deskfy-header/deskfy-header.directive'
import './core/directives/company-item/company-item.controller'
import './core/directives/company-item/company-item.directive'
import './core/directives/forms/forms.controller'
import './core/directives/forms/forms.directive'
import './core/directives/svg-icon/svg-icon.directive'
import './core/directives/input-yes-no/input-yes-no.controller'
import './core/directives/input-yes-no/input-yes-no.directive'
import './core/directives/dropdown-support/dropdown-support.directive'
import './core/directives/header-search/header-search.directive'
import './core/directives/header-search/header-search.controller'
import './core/directives/header-filter/header-filter.directive'
import './core/directives/header-filter/header-filter.controller'
import './core/directives/input-attachment/input-attachment.controller'
import './core/directives/input-attachment/input-attachment.directive'
import './core/directives/input-carrossel/input-carrossel.controller'
import './core/directives/input-carrossel/input-carrossel.directive'
import './core/directives/input-checkbox-list/input-checkbox-list.directive'
import './core/directives/input-checkbox-list/input-checkbox-list.controller'
import './core/directives/input-checkbox/input-checkbox.directive'
import './core/directives/input-checkbox/input-checkbox.controller'
import './core/directives/input-date/input-date.directive'
import './core/directives/input-date/input-date.controller'
import './core/directives/button-dropdown/button-dropdown.directive'
import './core/directives/button-dropdown/button-dropdown.controller'
import './core/directives/input-dropdown/input-dropdown.directive'
import './core/directives/input-dropdown/input-dropdown.controller'
import './core/directives/input-dropdown-multiple/input-dropdown-multiple.directive'
import './core/directives/input-dropdown-multiple/input-dropdown-multiple.controller'
import './core/directives/input-number/input-number.directive'
import './core/directives/input-number/input-number.controller'
import './core/directives/input-number-buttons/input-number-buttons.directive'
import './core/directives/input-number-buttons/input-number-buttons.controller'
import './core/directives/input-radio/input-radio.directive'
import './core/directives/input-radio/input-radio.controller'
import './core/directives/input-signature/input-signature.controller'
import './core/directives/input-signature/input-signature.directive'
import './core/directives/input-tags/input-tags.directive'
import './core/directives/input-tags/input-tags.controller'
import './core/directives/input-text/input-text.directive'
import './core/directives/input-text/input-text.controller'
import './core/directives/input-text-area/input-text-area.directive'
import './core/directives/input-text-area/input-text-area.controller'
import './core/directives/input-text-rich/input-text-rich.directive'
import './core/directives/input-text-rich/input-text-rich.controller'
import './core/directives/input-toggle-selector/input-toggle-selector.directive'
import './core/directives/input-toggle-selector/input-toggle-selector.controller'
import './core/directives/input-users/input-users.directive'
import './core/directives/input-users/input-users.controller'
import './core/directives/card-company-plans/card-company-plans.controller'
import './core/directives/card-company-plans/card-company-plans.directive'
import './core/directives/card-company-addons/card-company-addons.controller'
import './core/directives/card-company-addons/card-company-addons.directive'

import './core/directives/notification-menu/notification-menu.directive'
import './core/directives/notification-item/notification-item.directive'
import './core/directives/notification-central/notification-central.directive'
import './core/directives/notification-central/notification-central.controller'
import './core/directives/paging-control/paging-control.directive'
import './core/directives/saved-replies/saved-replies.directive'
import './core/directives/saved-replies/saved-replies.controller'
import './core/directives/sidebar-menu/sidebar-menu.directive'
import './core/directives/sidebar-second-level-menu/sidebar-second-level-menu.directive'
import './core/directives/sidebar-second-level-menu/sidebar-second-level-menu.controller'
import './core/directives/slider/slider.directive'
import './core/directives/slider/slider.controller'
import './core/directives/callback-on-last-repeater-item.directive'
import './core/directives/disable-email-validator.directive'
import './core/directives/emit-last-repeater-item.directive'
import './core/directives/img-fallback.directive'
import './core/directives/img-on-load.directive'
import './core/directives/img-on-error.directive'
import './core/directives/mark-image/mark-image.directive'
import './core/directives/mark-image/mark-image.controller'
import './core/directives/multiselect.directive'
import './core/directives/on-last-repeater-item.directive'
import './core/directives/refresher.directive'
import './core/directives/input-dropdown-inline/input-dropdown-inline.directive'
import './core/directives/table-columns/table-column-row-date/table-column-row-date.directive'
import './core/directives/table-columns/table-column-row-text/table-column-row-text.directive'
import './core/directives/table-columns/table-column-row-user/table-column-row-user.directive'
import './core/directives/table-columns/table-column-row-groups/table-column-row-groups.directive'
import './core/directives/table-columns/table-column-row-datetime/table-column-row-datetime.directive'
import './core/directives/table-columns/table-column-row-locale/table-column-row-locale.directive'
import './core/directives/table-columns/table-column-row-link/table-column-row-link.directive'
import './core/directives/table-columns/table-column-row-user-status/table-column-row-user-status.directive'
import './core/directives/table-columns/table-column-row-user-status/table-column-row-user-status.controller'
import './core/directives/table-columns/table-column-row-date/table-column-row-date.controller'
import './core/directives/table-columns/table-column-row-count-label/table-column-row-count-label.directive'
import './core/directives/core-data-frame-table/core-data-frame-table.controller'
import './core/directives/core-data-frame-table/core-data-frame-table.directive'
import './core/directives/core-filters/core-filters.controller'
import './core/directives/core-filters/core-filters.directive'
import './core/directives/core-horizontal-filters/core-horizontal-filters.controller'
import './core/directives/core-horizontal-filters/core-horizontal-filters.directive'
import './core/directives/core-filters/filters/core-filter-by/core-filter-by.controller'
import './core/directives/core-filters/filters/core-filter-by/core-filter-by.directive'
import './core/directives/core-filters/dropdowns/filter-groups-dropdown/filter-groups-dropdown.controller'
import './core/directives/core-filters/dropdowns/filter-groups-dropdown/filter-groups-dropdown.directive'
import './core/directives/core-filters/dropdowns/filter-users-dropdown/filter-users-dropdown.controller'
import './core/directives/core-filters/dropdowns/filter-users-dropdown/filter-users-dropdown.directive'
import './core/directives/core-filters/filters/core-filter-item/core-filter-item.directive'
import './core/directives/core-filters/dropdowns/filter-status-dropdown/filter-status-dropdown.controller'
import './core/directives/core-filters/dropdowns/filter-status-dropdown/filter-status-dropdown.directive'
import './core/directives/core-filters/dropdowns/filter-permissions-dropdown/filter-permissions-dropdown.controller'
import './core/directives/core-filters/dropdowns/filter-permissions-dropdown/filter-permissions-dropdown.directive'

import './core/dialogs/add-to-groups/add-to-groups-dialog.controller.js'
import './core/dialogs/add-to-groups/add-to-groups-dialog.directive.js'
import './core/dialogs/manage-user-status/manage-user-status-dialog.controller.js'
import './core/dialogs/manage-user-status/manage-user-status-dialog.directive.js'
import './core/dialogs/warning-message/warning-message-dialog.controller.js'
import './core/dialogs/warning-message/warning-message-dialog.directive.js'

import './arts/arts.routes'
import './arts/arts.controller'
import './arts/arts.service'
import './arts/custom-scripts/spectrum'
import './arts/directives/after-render.directive'
import './arts/directives/approval-list-filter/approval-list-filter.directive'
import './arts/directives/facebook-preview/facebook-preview.directive'
import './arts/directives/twitter-preview/twitter-preview.directive'
import './arts/directives/linkedin-preview/linkedin-preview.directive'
import './arts/directives/arts-list-filter/arts-list-filter.directive'
import './arts/directives/business-data-item/business-data-item.controller'
import './arts/directives/business-data-item/business-data-item.directive'
import './arts/directives/art-item/art-item.controller'
import './arts/directives/art-item/art-item.directive'
import './arts/directives/art-status-badge/art-status-badge.directive'
import './arts/directives/art-status-badge/art-status-badge.controller'
import './arts/directives/product-icon/product-icon.directive'
import './arts/directives/share-users/share-users.controller'
import './arts/directives/share-users/share-users.directive'
import './arts/directives/share-print-shop/share-print-shop.directive'
import './arts/directives/public-link/public-link.controller'
import './arts/directives/public-link/public-link.directive'
import './arts/directives/public-folder/public-folder.controller'
import './arts/directives/public-folder/public-folder.directive'
import './arts/directives/share-social-media/share-social-media.controller'
import './arts/directives/share-social-media/share-social-media.directive'
import './arts/directives/template-item/template-item.controller'
import './arts/directives/template-item/template-item.directive'
import './arts/directives/format-list/format-list.controller'
import './arts/directives/format-list/format-list.directive'
import './arts/directives/customize-format/customize-format.controller'
import './arts/directives/customize-format/customize-format.directive'
import './arts/directives/collection-item/collection-item.controller'
import './arts/directives/collection-item/collection-item.directive'
import './arts/directives/arts-search-filter/arts-search-filter.controller'
import './arts/directives/arts-search-filter/arts-search-filter.directive'
import './arts/dialogs/delete-section/delete-section-dialog.controller.js'
import './arts/dialogs/delete-section/delete-section-dialog.directive.js'
import './arts/filters/filter-time'
import './arts/filters/filter-long-date'
import './arts/pages/approval-list/approval-list.controller'
import './arts/pages/art-list/art-list.controller'
import './arts/pages/company-template-list/company-template-list.controller'
import './arts/pages/product-list/product-list.controller'
import './arts/pages/collection-list/collection-list.controller'
import './arts/pages/arts-page-customization/arts-page-customization.controller'
import './arts/pages/public-download/public-download.controller'
import './arts/pages/public-campaign/public-campaign.controller'
import './arts/services/art-import.service'
import './arts/services/art-collections.service'
import './arts/services/memo-template-request.service'
import './arts/services/editor-brand.service'
import './arts/services/elements-shapes.service'
import './arts/services/placeholder-elements.service'
import './arts/services/icon.service'
import './arts/services/use-terms.service'
import './arts/services/psd-import.service'
import './arts/services/share-link.service'
import './arts/services/special-shapes.service'
import './arts/services/schedule-art-share.service'
import './arts/services/text-shapes.service'
import './arts/services/print-shop.service'
import './arts/services/font-family-dropdown.service'
import './arts/dialogs/art-size/art-size-dialog.controller'
import './arts/dialogs/art-size/art-size-dialog.directive'
import './arts/directives/qrcode-app/qrcode-app.controller.js'
import './arts/directives/qrcode-app/qrcode-app.directive.js'
import './arts/pages/user/user.controller.js'
import './arts/pages/user/arts/user-arts.controller.js'
import './arts/pages/user/collection/user-collection.controller.js'
import './arts/pages/user/latest-news/user-latest-news.controller.js'
import './arts/pages/user/arts/search/user-search.controller.js'
import './arts/directives/user-search-bar/user-search-bar.controller.js'
import qrcodeGenerator from 'qrcode-generator'
import ngQrcode from 'angular-qrcode'

require('./assets/custom_components/semantic-ui/semantic')
require('moment/locale/es')
require('moment/locale/pt-br')
require('angular-moment-picker/dist/angular-moment-picker')
require('angular-ui-sortable/dist/sortable')
require('angular-avatar/dist/angular-avatar')
require('angular-content-editable/dist/angular-content-editable')
require('angular-trix/dist/angular-trix')
require('jquery-mask-plugin/dist/jquery.mask')
require('angular-lazy-img/release/angular-lazy-img')
require('ui-cropper/compile/minified/ui-cropper')
require('./assets/custom_components/jquery-ui-1.12.1.custom/jquery-ui')
require('./assets/custom_components/wheelzoom-master/wheelzoom')
require('./assets/custom_components/perfect-scrollbar/perfect-scrollbar.jquery')
require('angular-translate-once/src/translate-once')
require('deskfy-angular-bindonce/bindonce')

// TO DO - temporary workaround because angular is used in multiples files yet
window.angular = angular
window.jQuery = jQuery
window.$ = jQuery
window.qrcode = qrcodeGenerator

// Importing Unify Web Components
defineCustomElements()

const module = angular
  .module('deskfy', [
    coreModule.name,
    ngQrcode,
    adminModule.name,
    authModule.name,
    guestModule.name,
    homeModule.name,
    profileModule.name,

    artModule.name,
    auditModule.name,
    brandModule.name,
    postsModule.name,
    workflowModule.name,
    repositoryModule.name,
    campaignsModule.name,
    iaModule.name,
    documentsModule.name
  ])
  .config(deskfyConfig)
  .config(deskfyRoutes)
  .config(analyticsRoutes)
  .config(onboardingRoutes)
  .config(damRoutes)
  .config(repositoryRoutes)
  .config(campaignsRoutes)
  .config(documentsRoutes)
  .config(editorRoutes)
  .run(deskfyRun)

export const deskfyModule = module
